<div class="w-full bg-white">

    <!-- Header -->
    <div class="flex flex-row  justify-between items-center py-3 px-4 md:px-8 border-b">

        <!-- Title -->
        <div class="w-full flex items-center">
            <arrow-back></arrow-back>
            <div>
                <div 
                    class="text-2xl font-extrabold leading-7 tracking-tight sm:leading-10 md:text-4xl">
                    Reportes Sección {{ nombreSeccion }}
                </div>
            </div>
        </div>
        
    </div>

    <div class="flex flex-col md:flex-row md:items-stretch my-4 md:my-8 min-h-96 justify-between mx-4 md:mx-8 gap-8">
        <div class="bg-card shadow-md w-full md:w-4/12 rounded-md border">
            <mat-radio-group aria-label="Select an option" 
                class="flex flex-col gap-4 py-8 " 
                [(ngModel)]="reporteSeleccionado"
                (change)="onSeleccionarReporte($event.value)">
                @for(reporte of REPORTES; track reporte.tipo){
                    <mat-radio-button [value]="reporte.tipo" 
                    class="border-b-2 mx-8">
                    {{reporte.nombre}}
                </mat-radio-button>
                }

            </mat-radio-group>

        </div>
        <div class="w-full md:w-8/12">
            <form-descargar-reportes></form-descargar-reportes>
        </div>
    </div>
</div>